import { useNavigate, useParams } from "react-router-dom"
import { Input } from "../components/form/Input";
import { Switch } from "@mui/material";
import { addHours, format } from "date-fns";
import { et } from "date-fns/locale";
import { PrimaryButton } from "../components/buttons/PrimaryButton";
import { DeleteButton } from "../components/buttons/DeleteButton";
import { useAppDispatch } from "../store/hooks";
import { useEffect, useRef, useState } from "react";
import { addNotification, NotificationType } from "../store/features/notificationsSlice";
import api from "../api/apiInstance";
import { AxiosRequestConfig } from "axios";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { SpinnerContainer } from "../components/common/SpinnerContainer";
import { Spinner } from "../components/common/Spinner";
import { AdvertModel } from "../api/requests/interfaces/Advert";
import { deleteAdvert, getAdvertDetails, updateAdvert } from "../api/requests/advert";
import Popup from "../components/common/Popup";

export const AdvertDetailPage = () => {
    const {advertId} = useParams();
    const [isUpdatingPicture, setIsUpdatingPicture] = useState(false);
    const [loadingAdvert, setLoadingAdvert] = useState(false);
    const [updatingAdvert, setUpdatingAdvert] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [advertData, setAdvertData] = useState<AdvertModel | undefined>(undefined);
    const imageUploadRef = useRef<HTMLInputElement>(null);

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (advertId) {
            fetchAdvertData(Number(advertId));
        }
    }, [])

    const fetchAdvertData = async (advertId: number) => {
        setLoadingAdvert(true);
        const res = await getAdvertDetails(advertId);
        setAdvertData(res);
        setLoadingAdvert(false)
    }

    const handleUpdateAdvert = async () => {
        if (advertData) {
            setUpdatingAdvert(true);
            await updateAdvert(Number(advertId), {
                name: advertData.name,
                isActive: advertData.isActive,
                linkUrl: (advertData.linkUrl && advertData.linkUrl.length) ? advertData.linkUrl : undefined
            });
            dispatch(addNotification({ message: "Reklaam edukalt uuendatud", type: NotificationType.SUCCESS }));
            setUpdatingAdvert(false);
        }
    }

    const handleAdvertUpload = async (files: FileList | null) => {
        if (files === null || files?.item(0) === null) {
            return;
        }
        setIsUpdatingPicture(true);
        try {
            const config: AxiosRequestConfig = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            var data = new FormData();
            data.append('file', files[0]);
            const res = await api.post<string>(process.env.REACT_APP_RENTIC_API_URL! + "/files/upload_advert_picture/" + advertId!.toString(), data, config);
            await fetchAdvertData(Number(advertId));
            setIsUpdatingPicture(false);
            dispatch(addNotification({ message: "Reklaami pilt edukalt uuendatud", type: NotificationType.SUCCESS }));
        } catch {
            setIsUpdatingPicture(false);
            dispatch(addNotification({ message: "Reklaami pildi uuendmisel esines viga", type: NotificationType.ERROR }));
        }
    }

    const handleAdvertDelete = async () => {
        if (advertId) {
            await deleteAdvert(Number(advertId));
            navigate('/admin');
            dispatch(addNotification({ message: "Reklaami kustutatud", type: NotificationType.SUCCESS }));
        }
    }

    return (
        <div>
            {
                loadingAdvert ? 
                <Spinner />
                :
                <div>
                    {advertData ?
                    <SpinnerContainer show={updatingAdvert} fullWidth={true}>
                        <div>
                            <div className="flex flex-col sm:flex-row pt-2 gap-3">
                                <div className="basis-full sm:basis-2/5 relative">
                                    <SpinnerContainer show={isUpdatingPicture} fullWidth={true}>
                                        {
                                            advertData.pictureUrl.length ?
                                            <img src={advertData.pictureUrl} className="w-full object-contain rounded-lg min-h-[400px]"/>
                                            :
                                            <div className="w-full h-[300px] flex justify-center items-center font-bold">Pilt puudub</div>
                                        }
                                        <div className="absolute right-1 bottom-1 bg-gray-200 rounded-lg flex flex-row items-center p-1 cursor-pointer">
                                            <FileUploadOutlinedIcon style={{width: "20px", height: "20px"}} className=""/><div onClick={() => imageUploadRef.current?.click()}>Muuda</div>
                                            <input type="file" id="upload_pic" name="filename" className='hidden'
                                                                    accept="image/png,image/jpeg,image/jpg,image/heif,image/webp" ref={imageUploadRef} onChange={(e) => { handleAdvertUpload(e.target.files); e.target.files = null; }} />
                                        </div>
                                    </SpinnerContainer>
                                    {/* <div className="mt-1">
                                        <div>

                                        </div>
                                    </div> */}
                                </div>
                                <div className="basis-full sm:basis-3/5">
                                    <h4 className="text-left">Nimi</h4>
                                    <Input value={advertData.name} placeHolder="Toode" onChange={(v) => {setAdvertData({...advertData, name: v})}} />
                                    <h4 className="text-left pt-2">Lingi aadress</h4>
                                    <Input value={advertData.linkUrl ?? ""} placeHolder="Url" onChange={(v) => {setAdvertData({...advertData, linkUrl: v})}} />
                                    <div className="flex flex-col justify-start pt-2">
                                        <h4 className="text-left">Aktiivne</h4>
                                        <Switch
                                            checked={advertData.isActive}
                                            onChange={(v, ch) => {setAdvertData({...advertData, isActive: ch})}}
                                        />
                                    </div>
                                    <div className="flex flex-col justify-start pt-2">
                                        <h4 className="text-left">Loodud</h4>
                                        <span className="text-left">{format(addHours(advertData.createdAt, 2), 'dd. MMM, HH:mm yyyy', {locale: et})}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="flex gap-1 max-w-[200px] mt-2">
                                <PrimaryButton title="Salvesta" onClick={() => handleUpdateAdvert()}></PrimaryButton>
                                <DeleteButton title="Kustuta" onClick={() => {setShowDeletePopup(true)}} ></DeleteButton>
                            </div>
                        </div>
                    </SpinnerContainer>
                    :
                    <></>
                    }
                </div>
            }
            {showDeletePopup &&
                <Popup
                    message="Kas oled kindel, et kustutada reklaam?"
                    onConfirm={() => {handleAdvertDelete()}}
                    onCancel={() => {setShowDeletePopup(false)}}
                />
            }
        </div>
    )
}